import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SSOCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      // #14 — JWTs no longer travel via URL params; cookies are set
      // server-side on the SSO redirect, and loginWithToken validates
      // via /auth/me using those cookies.
      const redirectRaw = searchParams.get('redirect') || '/';
      // #46 — only accept same-site relative paths; an attacker-controlled
      // `redirect=https://evil.com` can otherwise pivot the user post-auth.
      const redirect = (redirectRaw.startsWith('/') && !redirectRaw.startsWith('//'))
        ? redirectRaw
        : '/';
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(errorParam);
        setTimeout(() => navigate('/login?error=' + errorParam), 2000);
        return;
      }

      try {
        await loginWithToken(null, null);
        navigate(redirect);
      } catch (err: unknown) {
        console.error('SSO login failed:', err);
        setError('Authentication failed');
        setTimeout(() => navigate('/login?error=sso_error'), 2000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-wmt-primary">
      <div className="text-center">
        <div className="alliance-card p-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_101bb3ff-a91b-44b5-9655-2a8dbd26c2f1/artifacts/dknvzqxd_alliance-branding-min-red.png" 
            alt="Alliance Logo" 
            className="h-12 w-auto mx-auto mb-4"
          />
          {error ? (
            <>
              <h2 className="text-xl font-semibold mb-2 text-wmt-primary">
                Authentication Error
              </h2>
              <p className="text-sm text-wmt-secondary">
                {error}. Redirecting to login...
              </p>
            </>
          ) : (
            <>
              <h2 className="text-xl font-semibold mb-2 text-wmt-primary">
                Completing Sign In...
              </h2>
              <p className="text-sm text-wmt-secondary">
                Please wait while we complete your authentication.
              </p>
              <div className="mt-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 mx-auto border-[var(--alliance-navy)]"></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SSOCallbackPage;
